module.exports = __webpack_public_path__ + "img/logo.c3f36a9.svg";